import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-background-50 via-primary-50/40 to-secondary-50">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 pb-16 pt-28 md:px-6 md:pt-32 lg:grid-cols-2">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-primary-700">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-sparkling-2-line text-sm" aria-hidden="true"></i>
            </span>
            {t("hero.eyebrow")}
          </span>

          <h1 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-5xl">
            {t("hero.h1")}
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            {t("hero.subtitle")}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#categories"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-center text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              {t("hero.ctaPrimary")}
            </a>
            <Link
              to="/usfans-spreadsheet-guide"
              className="whitespace-nowrap rounded-full border border-foreground-300 px-6 py-3 text-center text-sm font-bold text-foreground-800 transition-colors hover:bg-background-100"
            >
              {t("hero.ctaSecondary")}
            </Link>
          </div>

          <p className="mt-6 flex items-center gap-2 text-sm text-foreground-500">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line text-base text-primary-600" aria-hidden="true"></i>
            </span>
            {t("hero.trust")}
          </p>
        </div>

        <div className="w-full">
          <div className="relative mx-auto w-full max-w-md">
            <div className="absolute -inset-4 rounded-3xl bg-primary-100/50 blur-2xl" aria-hidden="true"></div>
            <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="h-52 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20tablet%20standing%20upright%20on%20a%20clean%20surface%20displaying%20a%20colorful%20organized%20product%20grid%20with%20thumbnail%20cards%2C%20a%20few%20folded%20garments%20and%20a%20single%20sneaker%20beside%20it%2C%20soft%20mint%20and%20cream%20tones%2C%20minimal%20editorial%20tech%20photography%2C%20high%20detail%2C%20no%20readable%20text&width=800&height=520&seq=hero-preview-01&orientation=landscape&nocache=true"
                  alt="USFans spreadsheet resource preview"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <span className="inline-block rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-bold text-secondary-900">
                  {t("hero.cardBadge")}
                </span>
                <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                  {t("hero.cardTitle")}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t("hero.cardText")}</p>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-primary-700 hover:underline"
                >
                  {t("hero.ctaPrimary")}
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}